'use strict';

_n.qsa('[neptune-interval]').forEach(function (el) {

  var _int = USON.parse(el.getAttribute('neptune-interval'))[0];

  el.cycle = 1;
  el.interval = setInterval(function () {

    el.cycle++;
    if (el.cycle > _n.qsa('.bg-img', el).length) el.cycle = 1;

    // _n.qs('[data-cycle-count]',el).innerHTML = el.cycle;

    Neptune.engage.action(_n.qs(_int.selector + ':nth-child(' + el.cycle + ')', el), _int.cycle);
  }, _int.every);

  if (!!_int.cancel) {
    el.addEventListener(_int.cancel, function (e) {
      clearInterval(el.interval);
    });
  }
});